import Api from '../global/api';  
const tariffReducer = (state = {
    status: 'LOADING',
    msg: '',
    data: []
}, action) => {
    let current_data = JSON.parse(JSON.stringify(state.data));
    const status = typeof action.status !== 'undefined' ? action.status.toUpperCase(): null;
    const idx = status === 'OK' ? current_data.findIndex(c => c.id_tariff === action.payload.id_tariff) : -1;

    switch(action.type){
        case "TARIFFS_LOAD":
            state = {
                ...state,
                status: status,
                msg: status === 'ERROR'?action.payload:'',
                data: status === 'OK'?action.payload:current_data
            }
            break;
        case "TARIFF_ADD":
            if(status === 'OK')
                current_data.push(action.payload);

            state = {
                ...state,
                status: status,
                msg: status === 'ERROR'?action.payload:'',
                data: current_data
            }
            break;
        case "TARIFF_UPDATE":
            if(status === 'OK' && idx > -1)
                current_data[idx] = action.payload;
                
            state = {
                ...state,
                status: status,
                msg: status === 'ERROR'?action.payload:'',
                data: current_data
            }
            Api.setLocal('tariffs', current_data);
            break;
        default:
    }
    return state;
}

export default tariffReducer;